import React, { useState, useEffect } from 'react'
import { Upload, Icon, message, Button, Typography, Input } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import * as dateFns from 'date-fns'
import { uploadFile, setUploadState } from '../../actions'
import { useAuth } from '../../authContext'
import  DatePicker, { disabledDateBefore, disabledTimeBefore } from "./DatePicker"
import { uploadMaxSize, isFileValid, isEndDateValid } from "../../utils/formValidation"
const { Dragger } = Upload
const { Title, Paragraph } = Typography

const Uploader = props => {
  const dispatch = useDispatch()
  const { user } = useAuth()
  const uploadSuccess = useSelector(state => state.ui.upload.uploadSuccess)
  const uploadStatusCode = useSelector(state => state.ui.upload.uploadStatusCode)
  const uploadResponseData = useSelector(state => state.ui.upload.uploadResponseData)

  const [fileList, setFileList] = useState([])
  const [endDate, setEndDate] = useState(null)
  const [isin, setIsin] = useState('')
  const [uploading, setUploading] = useState(false)

  const uploadToBackend = async () => {
    if (!isEndDateValid(endDate)) {
      return
    }
    if (fileList.length > 0) {
      const upload = new FormData()
      upload.append('file', fileList[0].originFileObj)
      if (dateFns.isValid(endDate)) {
        upload.append('endDate', endDate.toISOString())
      }
      if (user && user.upn) {
        upload.append('authorEmail', user.upn)
      }
      if (isin.trim()) {
        upload.append('isin', isin.trim())
      }
      setUploading(true)
      dispatch(uploadFile(upload))
    }
  }

  const handleChange = info => {
    let newFileList = [...info.fileList]
    newFileList = newFileList.slice(-1)

    // Validate file, do nothing if not valid
    if (newFileList.length > 0 && !isFileValid(newFileList[0])) {
      return
    }

    newFileList = newFileList.map(file => {
      file.url = URL.createObjectURL(file.originFileObj)
      return file
    })

    setFileList(newFileList)
  }

  const handleDateChange = (value) => {
    const dateValue = value ? dateFns.setSeconds(value, 0) : null
    isEndDateValid(dateValue)
    setEndDate(dateValue)
  }

  useEffect(() => {
    const uploadResponseErrorMsg = () => {
      const errorKeys = Object.keys(uploadResponseData.errors)
      return (
        <>
          <span>Error uploading - {uploadResponseData.message}</span>
          {errorKeys && errorKeys.length > 0 && (
            <>
              <br />
              <br />
              <ul style={{textAlign: "left"}}>
                {errorKeys.map(key => (
                  <li key={key}>{`${key}: ${uploadResponseData.errors[key]}`}</li>
                ))}
              </ul>
            </>
          )}
        </>
      )
    }

    if (uploadSuccess !== null) {
      if (uploadSuccess) {
        message.success('Uploaded successfully')
        setFileList([])
        setEndDate(null)
        setIsin('')
      } else if (uploadStatusCode === 413) {
        message.error('Error uploading, file size too big')
      } else {
        let content = 'Error uploading'
        if (uploadResponseData) {
          content = uploadResponseErrorMsg()
        }
        message.error(content, 5)
      }

      dispatch(setUploadState(null))
      setUploading(false)
    }
  }, [uploadSuccess, uploadStatusCode, uploadResponseData, dispatch])

  return (
    <div>
      <Paragraph>
        Please check your PDF for the following before uploading:
        <ul>
          <li>Field names does not include æ, ø, å or any other special characters</li>
          <li>Field names does not start with a number</li>
        </ul>
      </Paragraph>
      <Dragger
        name="file"
        multiple={false}
        onChange={info => {
          handleChange(info)
        }}
        beforeUpload={file => {
          return false
        }}
        fileList={fileList}
      >
        <p>
          <Icon type="file-add" />
        </p>
        <p className="ant-upload-text">Click or drag file to this area</p>
        <p className="ant-upload-hint">
          Upload one PDF file at a time (max. size {uploadMaxSize.pretty})
        </p>
      </Dragger>
      <br />
      <Title level={5}>Document expiration time</Title>
      <p>Optional, if set users can not sign the document after the selected date and time</p>
      <DatePicker
        value={endDate}
        onChange={value => handleDateChange(value)}
        showTime={{
          format: "HH:mm"
        }}
        disabledDate={disabledDateBefore}
        disabledTime={disabledTimeBefore}
        allowClear
      />
      <br />
      <br />
      <Title level={5}>ISIN</Title>
      <p>Optional. Required later if you want to export a VPS acceptance-form file for this deal.</p>
      <Input
        value={isin}
        onChange={e => setIsin(e.target.value.toUpperCase())}
        placeholder="e.g. NO0010911902"
        maxLength={12}
        style={{ maxWidth: 200 }}
      />
      <br />
      <br />
      <Button
        onClick={() => uploadToBackend()}
        disabled={uploading || fileList.length === 0}
      >
        Upload
      </Button>
    </div>
  )
}

export default Uploader
